/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react'
import _cloneDeep from 'lodash.clonedeep'
import _get from 'lodash.get'
import { useSelector } from 'react-redux'
import axios from 'axios'

import './styles.scss'
import ModalWrapper from '../ModalWrapper'
import { Button, TextNumberFormat } from 'components/Form'
import FormChannel from './FormChannel'
import Container from './fields/Container'
import { BrandsAndDelegations } from 'components/Form'
import { channels as channelsNewApi } from 'api'
import { channelName } from 'constants/channels'
import { toastMessage } from 'utils/messages'
import { HandbookButton } from 'components/common'
import { useHistory } from 'react-router-dom'
import DelegateResultModal from './ChatMail/AddAccountModals/DelegateResultModal'
import { Input } from 'reactstrap'
import Select from './fields/Select'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'

function ChannelTitle(props) {
  const { name, hub, accountType } = props

  let title = lang(name)
  const isChatmail = hub === 'chatmail'
  const isCorporate = accountType === 'corporate'

  if (isChatmail && isCorporate) {
    title += ` - ${lang('dashboard_corporate-account')}`
  }

  return (
    <h1>
      {title}
    </h1>
  )
}

const getDefaultChannel = (schema, company, brandAndDelegation = {}) => {
  return _cloneDeep({
    isNew: true,
    _id: `new_${Date.now()}`,
    company: company._id,
    companyType: company.type,
    type: 'channel',
    key: schema.key,
    hub: schema.hub,
    brandDefault: brandAndDelegation.brand || null,
    delegationDefault: brandAndDelegation.delegation || null,
    value: {},
    isEnabled: false,
  })
}

const Channels = (props) => {
  const { includedFreePrice } = useSelector(store => store.currentPlan)

  const { isOpen, toggle, channel, getChannels, accountType } = props
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [brandAndDelegation, setBrandAndDelegation] = React.useState({
    brand: null,
    delegation: null,
    error: false,
  })
  const [currentChannel, setCurrentChannel] = React.useState({})
  const [schema, setSchema] = React.useState({})
  const [isOpenContainer, setIsOpenContainer] = React.useState({
    configuration: true,
    messages: false,
    resources: false,
  })
  const [isOpenPublishAppModal, setIsOpenPublishAppModal] = React.useState(false)
  const companies = useSelector(store => store.companies)
  const [loading, setLoading] = React.useState(true)
  const [publishingApp, setPublishingApp] = React.useState(false)
  const history = useHistory()
  const [delegateResultModal, setDelegateResultModal] = React.useState({})
  const [isOpenOTPCodeRequestModal, setIsOpenOTPCodeRequestModal] = React.useState(false)
  const [isOpenOTPCodeVerification, setIsOpenOTPCodeVerification] = React.useState(false)
  const [codeRequestMethod, setCodeRequestMethod] = React.useState('sms')
  const [codeToSend, setCodeToSend] = React.useState(null)

  const toggleDelegateResultModal = () => setDelegateResultModal(prevState => ({ ...prevState, isOpen: !prevState.isOpen }))

  const handleUriError = async ({ isAdmin }) => {
    if (isAdmin) {
      setDelegateResultModal(prevState => ({ ...prevState, isLoadingMain: true }))
    } else {
      setDelegateResultModal(prevState => ({ ...prevState, isLoadingAlternative: true }))
    }

    try {
      const { data } = await channelsNewApi.uriError({ channelId: channel._id, errorType: 'admin_consent' })
      setDelegateResultModal(prevState => ({
        ...prevState,
        resultType: isAdmin ? 'consent-admin' : 'consent-operator',
        detailText: `${lang(isAdmin ? 'dashboard_press-to-allow-use-app' : 'dashboard_copy-to-admin-allow-app')}:`,
        textToCopy: !isAdmin ? data.redirectUri : null,
        onClickMain: isAdmin ? () => window.open(data.redirectUri, '_blank', 'noopener, noreferrer') : null
      }))
    } catch (error) {
      console.error(error)
    } finally {
      if (isAdmin) {
        setDelegateResultModal(prevState => ({ ...prevState, isLoadingMain: false }))
      } else {
        setDelegateResultModal(prevState => ({ ...prevState, isLoadingAlternative: false }))
      }
    }
  }

  React.useEffect(() => {
    try {
      const data = new URLSearchParams(history.location.search)

      // IS OK PARAM
      const isOk = data.get('isOk')
      if (isOk === 'true') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'ok',
          mainText: lang('dashboard_thats-it'),
          detailText: lang('channels_delegate_created'),
          onClickMain: toggleDelegateResultModal
        })
      }

      // ERROR PARAM
      const error = data.get('error')
      if (error === 'email_already_exists') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'warning',
          mainText: lang('dashboard_existing-email'),
          detailText: lang('channel_message_email_already_exists'),
          onClickMain: toggleDelegateResultModal
        })
      } else if (error === 'email_not_match') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'warning',
          mainText: lang('dashboard_email-not-registered'),
          detailText: lang('dashboard_channels_email-not-registered'),
          onClickMain: toggleDelegateResultModal
        })
      } else if (error === 'unknown_error') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'warning',
          mainText: 'Error',
          detailText: lang('dashboard_errors_default'),
          onClickMain: toggleDelegateResultModal
        })
      } else if (error === 'admin_consent') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'consent',
          mainText: lang('dashboard_consent-required'),
          detailText: lang('dashboard_channels_microsoft-admin-consent-required'),
          onClickMain: () => handleUriError({ isAdmin: true }),
          onClickAlternative: () => handleUriError({ isAdmin: false })
        })
      }

      // ADMIN CONSENT PARAM
      const adminConsent = data.get('adminConsent')
      if (adminConsent === 'accepted') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'ok',
          mainText: lang('dashboard_administrator-accept-permissions'),
          detailText: lang('dashboard_channels_chatmail-allowed'),
          onClickMain: toggleDelegateResultModal
        })
      } else if (adminConsent === 'rejected') {
        setDelegateResultModal({
          isOpen: true,
          resultType: 'warning',
          mainText: lang('dashboard_administrator-not-accept-permissions'),
          detailText: lang('dashboard_channels_chatmail-not-allowed'),
          onClickMain: toggleDelegateResultModal
        })
      }
    } catch (error) {
      console.error(error)
    }

    // GET SCHEMA
    initialData()
  }, [])

  const initialData = async () => {
    if (channel._id !== '0') {
      try {
        const dataChannel = await channelsNewApi.getById(channel._id)
        setCurrentChannel(dataChannel.data.channel)
        setSchema(dataChannel.data.schema)
        setBrands([{ value: dataChannel.data.channel.brandDefault, label: dataChannel.data.channel.brandName || '' }])
        setDelegations([{ value: dataChannel.data.channel.delegationDefault, label: dataChannel.data.channel.delegationName || '' }])
        setLoading(false)
      } catch ({ response = {}, message }) {
        const data = _get(response, 'data', {})
        toastMessage(lang(data.type || 'generic_error'), 'error')
        toggle()
      }
    }
    else {
      try {
        let key = channel.key
        let hub = channel.hub
        if (hub === 'chatmail') {
          key = 'imap'
        }
        const dataSchema = await channelsNewApi.getSchema(key, hub)
        if (Object.entries(dataSchema.data).length > 0) {
          setSchema(dataSchema.data)
          setCurrentChannel(getDefaultChannel(dataSchema.data, companies, brandAndDelegation))
          setLoading(false)
        }
        else {
          toastMessage(lang('generic_error'), 'error')
          toggle()
        }
      } catch ({ response = {}, message }) {
        const data = _get(response, 'data', {})
        toastMessage(lang(data.type || 'generic_error'), 'error')
        toggle()
      }
    }
  }

  React.useEffect(() => {
    setBrandAndDelegation({ ...brandAndDelegation, brand: brands.length > 0 ? brands[0].value : null })
  }, [brands])

  React.useEffect(() => {
    setBrandAndDelegation({ ...brandAndDelegation, delegation: delegations.length > 0 ? delegations[0].value : null })
  }, [delegations])

  const onNeedBrandAndDelegation = (value = true) => {
    setBrandAndDelegation({ ...brandAndDelegation, error: value })
  }

  const onUpdateChannel = (channel) => {
    setCurrentChannel(channel)
    getChannels()
  }

  const handlerPublishApp = async () => {
    setPublishingApp(true)

    try {
      await channelsNewApi.publishApp(currentChannel._id)
      setCurrentChannel({ ...currentChannel, state: 'REQUESTED' })
      setIsOpenPublishAppModal(!isOpenPublishAppModal)
    } catch (error) {
      setPublishingApp(false)
      console.error(error)
    }

    setPublishingApp(false)
  }

  const onOTPVerification = () => {
    setIsOpenOTPCodeRequestModal(true)
  }

  const verificationCodeRequest = async () => {
    try {
      setPublishingApp(true)

      await channelsNewApi.whatsappCodeRequest({
        method: codeRequestMethod,
        credential: currentChannel
      })

      setIsOpenOTPCodeRequestModal(false)
      setIsOpenOTPCodeVerification(true)
      setPublishingApp(false)
    } catch (error) {
      setIsOpenOTPCodeRequestModal(false)
      setPublishingApp(false)
      toastMessage(lang('whatsapp_already_verified_message'), 'error')
    }
  }

  const sendVerificationCode = async () => {
    try {
      await channelsNewApi.verifyWhatsappCode({
        code: codeToSend,
        credential: currentChannel
      })
      toastMessage(lang('whatsapp_code_verification_successful'))
      setIsOpenOTPCodeVerification(false)
    } catch(error) {
      if (axios.isAxiosError(error) && error.response.data.message === 'whatsapp_entered_code_not_valid') {
        toastMessage(lang(error.response.data.message), 'error')
      } else {
        toastMessage(lang('whatsapp_already_verified_message'), 'error')
        setIsOpenOTPCodeVerification(false)
      }
    }
    setPublishingApp(false)
  }

  const reSendVerificationCode = async () => {
    try {
      await channelsNewApi.whatsappCodeRequest({
        method: 'sms',
        credential: currentChannel
      })

      toastMessage(lang('whatsapp_re_sending_code'))
    } catch(error) {
      setPublishingApp(false)
      setIsOpenOTPCodeRequestModal(false)
      setIsOpenOTPCodeVerification(false)
      toastMessage(lang('whatsapp_already_verified_message'), 'error')
    }
  }

  return (
    <ModalWrapper
      id={`${isOpenContainer.resources ? 'modalChannelCreateEditApp' : 'modalChannelCreateEdit'}`}
      header={
        schema.key ? (
          <div className='modal-header-content'>
            <ChannelTitle
              name={channelName[schema.hub === 'whatsapp' ? `${schema.hub}_${schema.key}` : schema.key].name}
              hub={schema.hub}
              accountType={accountType}
            />
            {(currentChannel.state === 'PENDING' || currentChannel.state === 'REQUESTED') && schema.hub !== 'whatsapp' &&
              <Button
                primary={currentChannel.state === 'PENDING' ? true : false}
                disabled={currentChannel.state === 'REQUESTED' ? true : false}
                value={currentChannel.state === 'REQUESTED' ? lang('app_pending_publish') : lang('btn_publish_app')}
                onClick={() => setIsOpenPublishAppModal(!isOpenPublishAppModal)}
              />
            }
          </div>
        ) : null
      }
      body={
        <div className={`channels-create-edit ${isOpenContainer.resources ? 'channels-create-edit--app' : ''}`}>
          {loading
            ?
            <div className='containerSpinner' style={{ height: '100vh' }}>
              <Nixi1Spinner height='85vh' width='18%'/>
            </div>
            :
            <>
              {
                schema.handbook && (
                  <HandbookButton
                    text={lang('dashboard_you-need-help-configuration')}
                    buttonText={`${lang('dashboard_guide-to')} ${lang(`channels_${schema.hub === 'chatmail' ? schema.hub : schema.key}`)} (${lang('dashboard_pdf')})`}
                    handbookUrl={schema.handbook}
                  />
                )
              }
              <div className='modal-body'>
                {
                  Object.keys(schema.containers).map((it, idx) => (
                    <div key={idx}>
                      <Container isOpen={isOpenContainer[it]} setIsOpen={setIsOpenContainer} type={it}>
                        {
                          it === 'configuration' &&
                          <>
                            <BrandsAndDelegations
                              onChangeBrands={(value)=> {setBrands([value]); setCurrentChannel({ ...currentChannel, brandDefault: value.value })}}
                              currentBrands={brands || []}
                              onChangeDelegations={(value)=> setDelegations([value])}
                              currentDelegations={delegations || []}
                              multi={false}
                              isClearable
                              displayAllValues={false}
                            />
                            {<div className='error-brands'>{brandAndDelegation.error ? lang('error_required_brands_delegations') : ''}</div>}
                          </>
                        }
                        <FormChannel
                          type={it}
                          schema={schema}
                          company={companies}
                          currentChannel={currentChannel}
                          brandAndDelegation={brandAndDelegation}
                          onNeedBrandAndDelegation={onNeedBrandAndDelegation}
                          onUpdateChannel={onUpdateChannel}
                          onCancel={props.toggle}
                          isOpenContainer={isOpenContainer}
                          accountType={accountType}
                          onOTPVerification={onOTPVerification}
                        />
                      </Container>
                    </div>
                  ))
                }
              </div>
            </>
          }
          <ModalWrapper
            id='modalChannelPublishApp'
            isOpen={isOpenPublishAppModal}
            toggle={() => setIsOpenPublishAppModal(!isOpenPublishAppModal)}
            header={' '}
            body={
              schema.key === 'android'
                ? <p dangerouslySetInnerHTML={{ __html: lang(`android_app_publish_activation${includedFreePrice?.androidApp ? '_free' : ''}`) }}></p>
                : <p dangerouslySetInnerHTML={{ __html: lang(`ios_app_publish_activation${includedFreePrice?.iosApp ? '_free' : ''}`) }}></p>
            }
            footer={
              <div className='modal-publish-buttons'>
                <Button primary value={lang('modal_buttonText_publish')} onClick={handlerPublishApp} isSubmitting={publishingApp}/>
                <Button value={lang('dashboard_cancel')} onClick={() => setIsOpenPublishAppModal(!isOpenPublishAppModal)} />
              </div>
            }
          />
          {delegateResultModal.isOpen ? (
            <DelegateResultModal
              isOpen={delegateResultModal.isOpen}
              toggle={toggleDelegateResultModal}
              resultType={delegateResultModal.resultType}
              mainText={delegateResultModal.mainText}
              detailText={delegateResultModal.detailText}
              textToCopy={delegateResultModal.textToCopy}
              isLoadingMain={delegateResultModal.isLoadingMain}
              isLoadingAlternative={delegateResultModal.isLoadingAlternative}
              onClickMain={delegateResultModal.onClickMain}
              onClickAlternative={delegateResultModal.onClickAlternative}
            />
          ) : null}
          <ModalWrapper
            id='modalOTPCodeRequest'
            isOpen={isOpenOTPCodeRequestModal}
            toggle={() => setIsOpenOTPCodeRequestModal(!isOpenOTPCodeRequestModal)}
            header={
              <h3>{lang('whatsapp_verification_code_request_title')}</h3>
            }
            body={
              <>
                <p className='body'>{lang('whatsapp_verification_code_request')}</p>
                <div className='body-select'>
                  <Select
                    id='selectCodeMethod'
                    options={[{ value: 'sms', label: 'SMS' }, { value: 'voice', label: 'VOICE' }]}
                    label='whatsapp_verification_code_request_select'
                    placeholder='SMS'
                    value={codeRequestMethod}
                    onChange={data => setCodeRequestMethod(data)}
                  />
                </div>
              </>
            }
            footer={
              <div style={{ display: 'flex' }}>
                <Button primary value={lang('whatsapp_verification_code_request_btn')} isSubmitting={publishingApp} onClick={verificationCodeRequest}/>
                <Button value={lang('dashboard_cancel')} onClick={() => setIsOpenOTPCodeRequestModal(!isOpenOTPCodeRequestModal)} />
              </div>
            }
          />
          <ModalWrapper
            id='modalOTPCodeVerification'
            isOpen={isOpenOTPCodeVerification}
            toggle={() => setIsOpenOTPCodeVerification(!isOpenOTPCodeVerification)}
            header={<h3>{lang('whatsapp_code_verification_title')}</h3>}
            body={
              <div className='body'>
                <div className='body-input'>
                  <TextNumberFormat
                    defaultValue={false}
                    name='codeVerification'
                    customInput={Input}
                    onChange={value => setCodeToSend(value)}
                    className={'new-input'}
                    required
                    // invalid={errors.includes('bid_amount')}
                    format="### ###"
                  />
                </div>
                <p className='body-link'>{lang('whatsapp_verification_code_not_arrived')} <span onClick={reSendVerificationCode}>{lang('whatsapp_resend_code_by_sms')}</span> </p>
              </div>
            }
            footer={
              <div style={{ display: 'flex' }}>
                <Button primary value={lang('dashboard_verify')} onClick={sendVerificationCode}/>
                <Button value={lang('dashboard_cancel')} onClick={() => setIsOpenOTPCodeVerification(!isOpenOTPCodeVerification)} />
              </div>
            }
          />
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
      backdrop={'static'}
      keyboard={false}
      isOpenContainer={isOpenContainer}
    />
  )
}

export default Channels
